// 候補が多い項目を一覧から選ぶモーダル。車両選択と同じ操作にそろえる。
// モーダルへ後から読み込まれる入力でも動くよう、documentへ委譲する。
function scope(target: Element | null) {
    return target?.closest<HTMLElement>('[data-choice-picker]') ?? null;
}

function filter(root: HTMLElement) {
    const input = root.querySelector<HTMLInputElement>('[data-choice-filter]');
    const terms = (input?.value ?? '').normalize('NFKC').toLowerCase().split(/\s+/).filter(Boolean);
    let shown = 0;
    root.querySelectorAll<HTMLElement>('[data-choice-row]').forEach(row => {
        const text = (row.dataset.choiceRow ?? '').normalize('NFKC').toLowerCase();
        row.hidden = !terms.every(term => text.includes(term));
        if (!row.hidden) shown++;
    });
    const empty = root.querySelector<HTMLElement>('[data-choice-empty]');
    if (empty) empty.hidden = shown > 0;
}

export function initializeChoicePickers() {
    document.addEventListener('click', event => {
        const button = (event.target as Element | null)?.closest('button');
        const root = scope(button);
        if (!button || !root) return;
        const dialog = root.querySelector<HTMLDialogElement>('dialog')!;
        if (button.hasAttribute('data-choice-open')) { filter(root); dialog.showModal(); return; }
        if (button.hasAttribute('data-choice-close')) { dialog.close(); return; }
        if (button.hasAttribute('data-choice-clear')) {
            root.querySelector<HTMLInputElement>('[data-choice-value]')!.value = '';
            root.querySelector<HTMLInputElement>('[data-choice-display]')!.value = '';
            return;
        }
        if (button.dataset.choiceId) {
            root.querySelector<HTMLInputElement>('[data-choice-value]')!.value = button.dataset.choiceId;
            root.querySelector<HTMLInputElement>('[data-choice-display]')!.value = button.dataset.choiceName ?? '';
            dialog.close();
        }
    });
    document.addEventListener('input', event => {
        const target = event.target as HTMLElement | null;
        if (!target?.hasAttribute('data-choice-filter')) return;
        const root = scope(target);
        if (root) filter(root);
    });
}

// 「車番紐付けなし」を入れている間は実車両を選ばせない。既に選んだ値も外す。
export function initializeNoVehicleLink() {
    document.addEventListener('change', event => {
        const toggle = (event.target as Element | null)?.closest<HTMLInputElement>('[data-no-vehicle-link]');
        if (!toggle) return;
        sync(toggle);
    });
    document.querySelectorAll<HTMLInputElement>('[data-no-vehicle-link]').forEach(sync);

    function sync(toggle: HTMLInputElement) {
        const area = toggle.closest('form')?.querySelector<HTMLElement>('[data-actual-vehicle]');
        if (!area) return;
        area.hidden = toggle.checked;
        if (toggle.checked) {
            const value = area.querySelector<HTMLInputElement>('[data-choice-value]');
            const display = area.querySelector<HTMLInputElement>('[data-choice-display]');
            if (value) value.value = '';
            if (display) display.value = '';
        }
    }
}
